<div class="page-layout blank">
  <mat-horizontal-stepper class="orbitax-form-container" [linear]="true">
    <mat-step [stepControl]="horizontalStepperStep1">
      <form [formGroup]="Form" class="flex flex-col">
        <ng-template matStepLabel>Import Details</ng-template>
        <div class="p-l-30 p-r-30 min-height simple-scroll flex flex-col flex-1-0-auto">
          <div class="m-b-30 flex flex-row justify-start items-start auto-flex">
            <particle-file-selector [(file)]="FileToUpload" class="flex flex-col flex-1-1-50"
                                    [legend]="'Transaction Data (Excel)'"
                                    [required]="true">
            </particle-file-selector>
          </div>
          <div class="m-b-30 flex flex-row justify-start items-start auto-flex">
            <div class="warning-note flex-1-1-50" *ngIf=ImportFile>
              <span>Note:</span> Orbitax Change Reports supports the import of transaction data templates from various
              applications (including Orbitax Essentials, ONESOURCE International Tax Calculator and ONESOURCE BEPS
              Action Manager). Alternatively, you can download and populate the basic <a role="button"
                                                                                         (click)="transactionDataTemplateDownload()"
                                                                                         style="cursor: pointer"> {{ImportFile.name}}</a>
              for import.
            </div>
          </div>
          <div class="flex flex-row justify-start items-start auto-flex">
            <fieldset class="checkbox-fieldset flex-1-1-50">
              <legend> Import settings</legend>
              <mat-checkbox formControlName="replaceExistingSelection"
                            particleAnalytics
                            analyticsCategory="transaction-import"
                            analyticsAction="checkbox">
                Replace all existing country selections with imported data
              </mat-checkbox>
            </fieldset>
          </div>
        </div>

        <div class="form-footer flex flex-row justify-between items-center">
          <button mat-button class="mat-flat-button orbitax-footer-button" (click)=cancel()>Cancel</button>
          <button mat-flat-button matStepperNext class="orbitax-footer-action-button mat-button" type="button"
                  color="accent" (click)=done()>
            Done
          </button>
        </div>


      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>
